import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import {
  getIdentityProTrackStartBusinessDate,
  getIdentityActiveProTrackName,
  getShowUserProTrackStartBlock,
} from 'store/entities/identity/selectors'
import UserProTrackStartBlock from './UserProTrackStartBlock'

const mapStateToProps = createStructuredSelector({
  startDate: getIdentityProTrackStartBusinessDate,
  proTrackName: getIdentityActiveProTrackName,
  show: getShowUserProTrackStartBlock,
})

export default connect(mapStateToProps)(UserProTrackStartBlock)
